__turbopack_context__.v({
  "accordionList": "rail-menu-module-scss-module__Oxym5a__accordionList",
  "authFooter": "rail-menu-module-scss-module__Oxym5a__authFooter",
  "avatarChip": "rail-menu-module-scss-module__Oxym5a__avatarChip",
  "chevron": "rail-menu-module-scss-module__Oxym5a__chevron",
  "chevronDown": "rail-menu-module-scss-module__Oxym5a__chevronDown",
  "chevronDownOpen": "rail-menu-module-scss-module__Oxym5a__chevronDownOpen",
  "crawlerExpandable": "rail-menu-module-scss-module__Oxym5a__crawlerExpandable",
  "crawlerNestedList": "rail-menu-module-scss-module__Oxym5a__crawlerNestedList",
  "expandableRow": "rail-menu-module-scss-module__Oxym5a__expandableRow",
  "flyout": "rail-menu-module-scss-module__Oxym5a__flyout",
  "fullscreenContent": "rail-menu-module-scss-module__Oxym5a__fullscreenContent",
  "fullscreenHeader": "rail-menu-module-scss-module__Oxym5a__fullscreenHeader",
  "fullscreenHeaderWrap": "rail-menu-module-scss-module__Oxym5a__fullscreenHeaderWrap",
  "fullscreenLogo": "rail-menu-module-scss-module__Oxym5a__fullscreenLogo",
  "fullscreenLogoLink": "rail-menu-module-scss-module__Oxym5a__fullscreenLogoLink",
  "fullscreenMenu": "rail-menu-module-scss-module__Oxym5a__fullscreenMenu",
  "icon": "rail-menu-module-scss-module__Oxym5a__icon",
  "itemIcon": "rail-menu-module-scss-module__Oxym5a__itemIcon",
  "itemIconChip": "rail-menu-module-scss-module__Oxym5a__itemIconChip",
  "itemLabel": "rail-menu-module-scss-module__Oxym5a__itemLabel",
  "label": "rail-menu-module-scss-module__Oxym5a__label",
  "menuItem": "rail-menu-module-scss-module__Oxym5a__menuItem",
  "menuItemActive": "rail-menu-module-scss-module__Oxym5a__menuItemActive",
  "menuList": "rail-menu-module-scss-module__Oxym5a__menuList",
  "navButton": "rail-menu-module-scss-module__Oxym5a__navButton",
  "signOutIconChip": "rail-menu-module-scss-module__Oxym5a__signOutIconChip",
  "signOutItem": "rail-menu-module-scss-module__Oxym5a__signOutItem",
  "subMenuItem": "rail-menu-module-scss-module__Oxym5a__subMenuItem",
  "subMenuList": "rail-menu-module-scss-module__Oxym5a__subMenuList",
  "subPanel": "rail-menu-module-scss-module__Oxym5a__subPanel",
  "trigger": "rail-menu-module-scss-module__Oxym5a__trigger",
  "wrap": "rail-menu-module-scss-module__Oxym5a__wrap",
  "wrapMobile": "rail-menu-module-scss-module__Oxym5a__wrapMobile",
});
